import { render, staticRenderFns } from "./DashboardPage.html?vue&type=template&id=72f21d08&scoped=true&"
import script from "./DashboardPage.ts?vue&type=script&lang=ts&"
export * from "./DashboardPage.ts?vue&type=script&lang=ts&"
import style0 from "./DashboardPage.scss?vue&type=style&index=0&id=72f21d08&scoped=true&lang=scss&"
import style1 from "./DashboardPage_unscoped.scss?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f21d08",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VContainer,VIcon,VImg,VSelect,VTextField})
